module.exports = __webpack_public_path__ + "static/media/U1-T1-2-2.e8509862.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/U1-T1-2-2.mp4
// module id = 521
// module chunks = 0